import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { JsonViewerComponent } from './json-viewer.component';
import { JsonHighlightComponent } from '@smartcharge/portal/shared/components/json-highlight/json-highlight.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDialogModule,
    MatIconModule,
    RouterModule,
    PipesModule,
    NgxJsonViewerModule,
    JsonHighlightComponent,
    A11yModule
  ],
  declarations: [JsonViewerComponent]
})
export class JsonViewerModule {}
